// ------------------
// Imports
// ------------------
import 'pinia';
import axios from 'axios';
// @ts-ignore
import Retry, { RetryableError } from './axios-retry';
// ------------------
// Errors
// ------------------
class IncompleteResponse extends RetryableError {
    constructor(response) {
        super('Incomplete response', response);
    }
}
// ------------------
// Canceller
// ------------------
const Canceller = {
    store: [],
    create() {
        const source = new AbortController();
        this.store.push(source);
        return source;
    },
    delete(source) {
        const index = this.store.indexOf(source);
        if (index === -1)
            return;
        this.store.splice(index, 1);
    },
    abort(source) {
        this.delete(source);
        source.abort();
    },
    reset() {
        this.store.forEach((source) => source.abort());
        this.store.length = 0;
    },
};
// ------------------
// Exports
// ------------------
const API = (Axios, config) => ({
    Axios,
    call(key, ...args) {
        if (!(key in config))
            throw new Error(`No API config found for key ${key}`);
        const cfg = config[key](...args);
        const canceller = Canceller.create();
        return Axios({
            ...cfg,
            signal: canceller.signal,
            headers: cfg.headers,
        });
    },
    abort() {
        Canceller.reset();
    },
});
let globalApi = null;
export function createAPI(options) {
    // ------------------
    // Instance
    // ------------------
    const Axios = Retry(axios.create({
        baseURL: options.origin,
        withCredentials: true,
    }));
    // ------------------
    // Interceptors
    // ------------------
    Axios.interceptors.response.use((response) => {
        const { config, headers } = response;
        const value = headers['x-krakend-completed'];
        if (value) {
            if (config.complete && value !== 'true') {
                return Promise.reject(new IncompleteResponse(response));
            }
        }
        return response;
    });
    const api = API(Axios, options.config);
    return globalApi = api;
}
export const plugin = {
    install(app, api) {
        app.config.globalProperties.$axios = api.Axios;
        app.config.globalProperties.$api = api;
    }
};
// ------------------
// Exports
// ------------------
export default globalApi;
